module.exports = __webpack_public_path__ + "img/license.ea22b83.svg";